export default __webpack_public_path__ + "static/media/penDark.5696795a.svg";